import { Grid, Button, Typography } from '@mui/material';
import React from 'react';
import ApiService from '../../../../../services/ApiService';
import { useState } from 'react';
import { formatCurrency } from '../../../../../services/ApiService';
import DollarInput from '../../../../../components/Masks/DollarInput';
import RupiahInput from '../../../../../components/Masks/RupiahInput';

import SelectDataCashAdvance from '../Selects/SelectDataCashAdvance';
import { Input, showToast } from '../../../../../components/ui';
import { convertToNominal, convertToNumeric } from '../../../../../utils/masks.jsx';

const CashAdvSettlementDetail = (props) => {
    const [titleModalCA, setTitleModalCA] = useState('');
    const [isModalCA, setIsModalCA] = useState(false);
    const paramCA = "cashAdvance/cashAdvance";
    const [isLoadingCA, setIsLoadingCA] = useState(false);
    const [dataCA, setDataCA] = useState([]);
    const [SelectedDataCA, setSelectedDataCA] = useState({});
    const [totalRowsCA, setTotalRowsCA] = useState(50);
    const [dataMapCA, setDataMapCA] = useState([]);
    const [columnDataCA, setColumnDataCA] = useState([]);

    const handleClickBalance = () => {
        if (isModalCA === false) {
            setIsModalCA(true);
            getDataCashAdvance(1, 50);
        }
        else {
            setIsModalCA(false);
        }
    };

    const searchBalance = (data) => {
        if (data === 'search') {
            if (props.EmployeeId !== 0) {
                setTitleModalCA('Balance');
                handleClickBalance();
            }
            else {
                showToast({ type: 'error', message: 'Please Select Data Personal First!' });
            }
        }
    };

    const getDataCashAdvance = (pageNumber, pageSize, filters) => {
        setIsLoadingCA(true);
        let param = [
            { 'attr': 'employeeId', 'value': '' + props.EmployeeId }
        ];
        ApiService.FinAccPostByPage(paramCA, 'SEARCH', pageNumber, pageSize, param, filters)
            .then((response) => {
                if (response.data.code === 200) {
                    setSelectedDataCA({});
                    setDataCA(response.data.data.cashAdvance);

                    let temp = response.data.data.cashAdvance
                    let indexed = temp.map((el, index) => {
                        let indexedTemp = {
                            ...el,
                            index
                        }
                        return indexedTemp
                    })

                    setDataMapCA(indexed);
                    setColumnDataCA(response.data.data.columns.headerColumns);
                    setTotalRowsCA(response.data.totalRowCount);

                    setIsLoadingCA(false);
                }
                setIsLoadingCA(false);
            })
            .catch(function (error) {
                setIsLoadingCA(false);
                console.error('error saat fetch', error);
                showToast({ type: 'error', message: error.toString() });
            })
    };

    function handleTotalUSD(value) {
        let val = parseFloat(convertToNumeric(value));

        if (props.CashAdvanceId !== 0) {
            props.setTotalUSD(val);
            let countSettlementUSD = parseFloat(props.BalanceSettlementUSDReal) + parseFloat(val);
            props.setBalanceSettlementUSD(convertToNominal(countSettlementUSD));
            props.calculateBalance(props.TotalIDR, val, props.BalanceCAIDRReal, props.BalanceCAUSDReal, props.BalanceSettlementIDRReal, props.BalanceSettlementUSDReal);
        }
        else {
            showToast({ type: 'error', message: 'Please Input No More Than Balance Per Cash Advance USD' });
        }
    }

    function handleTotalIDR(value) {
        let val = parseFloat(convertToNumeric(value));

        if (props.CashAdvanceId !== 0) {
            props.setTotalIDR(val);
            let countSettlementIDR = parseFloat(props.BalanceSettlementIDRReal) + parseFloat(val);
            props.setBalanceSettlementIDR(convertToNominal(countSettlementIDR));
            props.calculateBalance(val, props.TotalUSD, props.BalanceCAIDRReal, props.BalanceCAUSDReal, props.BalanceSettlementIDRReal, props.BalanceSettlementUSDReal);
        }
        else {
            showToast({ type: 'error', message: 'Please Input No More Than Balance Per Cash Advance IDR' });
        }
    }

    return (
        <div>
            <form>
                <Grid
                    container
                    spacing={'32px'}
                >
                    <Grid
                        item
                        xl={4}
                        lg={4}
                        sm={4}
                        xs={12}
                    >
                        <div>
                            <Typography
                                sx={{
                                    color: 'var(--Blue-Primary-1, #083A50)',
                                    fontFamily: 'Nunito',
                                    fontSize: '18px',
                                    fontStyle: 'normal',
                                    fontWeight: '600',
                                    lineHeight: 'normal',
                                }}
                            >
                                Settlement
                            </Typography>

                            <Grid
                                container
                                spacing={'16px'}
                            >
                                <Grid
                                    item
                                    xl={12}
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                >
                                    <Input
                                        label="Total USD"
                                        value={props.TotalUSD}
                                        onChange={(e) => handleTotalUSD(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                        inputBaseProps={{
                                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                        }}
                                        disabled={props.Printing > 0 ? true : false}
                                    />

                                    <Input
                                        label="Total IDR"
                                        value={props.TotalIDR}
                                        onChange={(e) => handleTotalIDR(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                                marginTop: '16px !important'
                                            }
                                        }}
                                        inputBaseProps={{
                                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                        }}
                                        disabled={props.Printing > 0 ? true : false}
                                    />

                                    <Button
                                        size='small'
                                        variant="outlined"
                                        className='d-flex align-items-center'
                                        disabled={props.Printing > 0 ? true : false}
                                        // disabled = {props.printing > 0? true : false}
                                        sx={{
                                            padding: '6px 24px !important',
                                            gap: '8px',
                                            width: '100%',
                                            marginTop: '37px !important',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '8px',
                                            border: props.Printing > 0 ? '2px solid #989898' : null,
                                            background: props.Printing > 0 ? '#EAEAEA' : 'var(--Blue-Button-Primary-1, #2A8D36)',
                                            '&:hover': {
                                                backgroundColor: 'var(--Blue-Button-Primary-1, #2A8D36) !important',
                                                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.20)',
                                            }
                                        }}
                                        onClick={() => searchBalance()}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily: 'Nunito',
                                                fontSize: '14px',
                                                fontWeight: '700',
                                                lineHeight: '20px',
                                                letterSpacing: '0em',
                                                textAlign: 'center',
                                                color: props.Printing > 0 ? '#989898' : '#E4E8EC',
                                            }}
                                        >
                                            BALANCE OF OVERALL CASH ADVANCE
                                        </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>

                    <Grid
                        item
                        xl={8}
                        lg={8}
                        sm={8}
                        xs={12}
                    >
                        <div>
                            <Typography
                                sx={{
                                    color: 'var(--Blue-Primary-1, #083A50)',
                                    fontFamily: 'Nunito',
                                    fontSize: '18px',
                                    fontStyle: 'normal',
                                    fontWeight: '600',
                                    lineHeight: 'normal',
                                }}
                            >
                                Balance
                            </Typography>

                            <Grid
                                container
                                spacing={'32px'}
                            >
                                <Grid
                                    item
                                    xl={6}
                                    lg={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <Input
                                        label="Balance Per Cash Advance IDR"
                                        value={props.BalanceCAIDR}
                                        onChange={(e) => props.setBalanceCAIDR(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                    />

                                    <Input
                                        label="Balance Settlement IDR"
                                        value={props.BalanceSettlementIDR}
                                        onChange={(e) => props.setBalanceSettlementIDR(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                                marginTop: '16px !important'
                                            }
                                        }}
                                        inputBaseProps={{
                                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                        }}
                                    />

                                    <Input
                                        label="Balance IDR"
                                        value={props.BalanceIDR}
                                        onChange={(e) => props.setBalanceIDR(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                                marginTop: '16px !important'
                                            }
                                        }}
                                    />
                                </Grid>

                                <Grid
                                    item
                                    xl={6}
                                    lg={6}
                                    sm={6}
                                    xs={12}
                                >
                                    <Input
                                        label="Balance Per Cash Advance USD"
                                        value={props.BalanceCAUSD}
                                        onChange={(e) => props.setBalanceCAUSD(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                            }
                                        }}
                                    />

                                    <Input
                                        label="Balance Settlement USD"
                                        value={props.BalanceSettlementUSD}
                                        onChange={(e) => props.setBalanceSettlementUSD(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                                marginTop: '16px !important'
                                            }
                                        }}
                                        inputBaseProps={{
                                            inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                                        }}
                                    />

                                    <Input
                                        label="Balance USD"
                                        value={props.BalanceUSD}
                                        onChange={(e) => props.setBalanceUSD(e.target.value)}
                                        textAlign='right'
                                        fullWidth
                                        disabled
                                        formControlProps={{
                                            sx: {
                                                width: '100%',
                                                marginTop: '16px !important'
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </form>

            {
                isModalCA && (
                    <SelectDataCashAdvance
                        isModal={isModalCA}
                        handleClick={handleClickBalance}
                        titleModal={titleModalCA}
                        setIsModal={setIsModalCA}
                        getData={getDataCashAdvance}
                        isLoading={isLoadingCA}
                        totalRows={totalRowsCA}
                        setTotalRows={setTotalRowsCA}
                        SelectedData={SelectedDataCA}
                        setSelectedData={setSelectedDataCA}
                        data={dataCA}
                        columnData={columnDataCA}
                        dataMap={dataMapCA}
                        setCashAdvanceId={props.setCashAdvanceId}
                        setCashAdvanceNo={props.setCashAdvanceNo}
                        setBalanceCAIDR={props.setBalanceCAIDR}
                        setBalanceCAUSD={props.setBalanceCAUSD}
                        TotalIDR={props.TotalIDR}
                        TotalUSD={props.TotalUSD}
                        calculateBalance={props.calculateBalance}
                    />
                )
            }
        </div>
    )
}

export default CashAdvSettlementDetail;